import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { addStock } from "../../../Redux/actions/adminActions/medicineActions.js";
import { showToast } from "../../ToastMessage.jsx";
/**
 * show, onHide, medicine
 */
const AddStockModal = ({ show, onHide, medicine, refresh }) => {
  const dispatch = useDispatch();
  const [qty, setQty] = useState("");

  if (!show || !medicine) return null;

  const submit = async (e) => {
    e.preventDefault();
    const q = Number(qty);
    
    // ✅ Validate quantity
    if (!q || q <= 0) {
      alert("Enter valid quantity (must be greater than 0)");
      return;
    }
    if (q > 100000) {
      alert("Quantity is too large (max 100000)");
      return;
    }
    
    try {
      await dispatch(addStock(medicine._id, q));
      showToast("Stock added successfully!");
      refresh(); // ✅ Trigger reload
      onHide();
    } catch (err) {
      showToast(err.response?.data?.msg || "Failed to add stock");
    }
  };

  return (
    <div className="modal d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog">
        <div className="modal-content p-3">
          <h5>Add Stock — {medicine.name}</h5>
          <form onSubmit={submit}>
            <input
              className="form-control my-2"
              type="number"
              placeholder="Quantity"
              value={qty}
              onChange={(e) => setQty(e.target.value)}
               min="1" // ✅ Add min
               max="100000"
            />
            <div className="d-flex gap-2">
              <button className="btn btn-warning" type="submit">
                Add
              </button>
              <button
                className="btn btn-secondary"
                type="button"
                onClick={onHide}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddStockModal;
